export const AUTH_TOKEN_KEY = "as_auth_token";
export const REFRESH_TOKEN_KEY = "as_refresh_token";
export const JUST_VERIFIED_KEY = "justVerified";
export const AUTH_CODE_LENGTH = 4;

export const DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

export const LANGUAGE_KEY = "immo_lang";

export const BOOKING_HASH_KEY = "booking_hash";
